// Func = limiting Scope for this file

(function(){
	function scrollDown(){
		var top = $(document).scrollTop();
		var heroHeight = $('.hero').outerHeight();
		var bookingHeight = $('#home-booking-widget').outerHeight();
		var docHeight = $(document).height();
		var footerHeight = $('.footer').outerHeight() / 2;

		if (top > (heroHeight + bookingHeight + 92)) {
			$('.booking-benefits').addClass('booking-benefits--sticky');
			// $('.booking-benefits__trigger').removeClass('booking-benefits__trigger--open');
			// $('.booking-benefits__items').slideUp(600);
		} else {
			$('.booking-benefits').removeClass('booking-benefits--sticky');
			// $('.booking-benefits__trigger').addClass('booking-benefits__trigger--open');
			// $('.booking-benefits__items').slideDown(600);
		}

		if($(window).scrollTop() + $(window).height() > docHeight - footerHeight) {
			$('.booking-benefits').addClass('booking-benefits--hide');
		} else {
			$('.booking-benefits').removeClass('booking-benefits--hide');
		}
	} 

	function headerHeight(){
		var header_topHeight = $('.header__top').outerHeight();
		var header_navHeight = $('.header__nav').outerHeight();
		var fullHeight = header_topHeight + header_navHeight;

		$('.header').css('height', fullHeight);
	}

	$(document).ready(function () {

		//Call function with browser is resized.
		//$(window).resize(function (event) {
		//	resizeWindow();
		//});
		//resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//headerHeight();
			scrollDown();
		});

		if ($(".topalert")[0]){
			$('body').css('margin-top', 60);
			$('.header').css('top', 60);
		}

		//Navigation Dropdown
		$('.header__menu-trigger').click(function(){
			$(this).toggleClass('header__menu-trigger--open');
			$('.header__nav').slideToggle();
			$('.menu-text--default, .menu-text--close').fadeToggle();
		});

		$('.header__booking-trigger').click(function(){
			$('.booking-widget').slideToggle();
			$(this).toggleClass('active');
			$('.header__booking-trigger--open, .header__booking-trigger--close').fadeToggle();

			// if($(this).hasClass('active')) {
			// 	$(this).html('Close');
			// } else {
			// 	$(this).html('Book Now');
			// }

			$('#content').click(function(e){
				e.preventDefault;
				$('.booking-widget').slideUp();
				$('.header__booking-trigger').removeClass('active');
				$('.header__booking-trigger--open').fadeIn();
				$('.header__booking-trigger--close').fadeOut();
			});
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Book Direct Benefits menu
		$('.booking-benefits__trigger').click(function(){
			$(this).toggleClass('booking-benefits__trigger--open');
			$('.booking-benefits__items').slideToggle(600);
		});

		$('.hero__video').prop('muted', true);

		$('.hero__volume').click(function(){
			if($(this).hasClass('hero__volume--turn-on')) {
				$(this).removeClass('hero__volume--turn-on');
				$(this).addClass('hero__volume--turn-off');

				$(this).children('span').html('Turn Volume Off');
			} else {
				$(this).removeClass('hero__volume--turn-off');
				$(this).addClass('hero__volume--turn-on');

				$(this).children('span').html('Turn Volume On');
			}

			if( $('.hero__video').prop('muted') ) {
				$(".hero__video").prop('muted', false);
			} else {
				$(".hero__video").prop('muted', true);
			}

			
		});
        
		
		document.querySelectorAll('.js-roomtarget').forEach((value, key)=>{
			value.addEventListener('click' , ()=>{
				setTimeout(()=>{
					let menu_hash = window.location.hash.split("#")[1]
					let location_hash= document.querySelector(`[data-tag='${menu_hash}']`);
					document.querySelector(`[data-tag='${menu_hash}']`).click()
					$('html, body').animate({ scrollTop: $('#moduleFilter').offset().top - 10 }, 1000);
				},500)
				
			})
		})


		$('.language li a').click(function(){
			$('.lang-selected').html($(this).text());	// Full text
			$('.language').fadeToggle();
		});
		$('.lang-selected').click(function(){
			$('.language').toggleClass('active').fadeToggle();
		});



		// VIDEO MODULE
		// var video = document.getElementById("myVideoPlayer");
		var videoList = document.getElementsByTagName("video");
		function stopVideo(){
			for (var i = 0; i < videoList.length; i++) {
				videoList[i].pause();
				videoList[i].currentTime = 0;
			}
		}

		$('.video-module__trigger').click(function(){
			var videoId = $(this).data('tag');

			$('#video-module__popup-' + videoId).fadeIn();
			document.getElementById('myVideoPlayer-' + videoId).play();
		});

		$('.video-module__close').click(function(){
			$('.video-module__popup').fadeOut();
			stopVideo();
		});

		$('.testimonials').slick({
			arrows: false,
			dots: true,
			speed: 500,
			fade: true,
			autoplay: true,
			autoplaySpeed: 5000,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						arrows: true,
						dots: false
					}
				}
			]
		});

		// Fancybox options
		$('.fancybox').fancybox();

		$('.fancybox-module').fancybox({
			maxWidth: 800,
			wrapCSS: 'module__popup-wrapper'
		});
	
		$('.fancybox-form').fancybox({
			maxWidth: 1170,
			wrapCSS: 'module__popup-wrapper'
		});
		
	});
	// Booking datepicker
		$( "#CheckIn1" ).datepicker({
			changeMonth: true,
			dateFormat: "yy-mm-dd",
			numberOfMonths: 1,
			minDate: 0,

			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut1" ).datepicker( "setDate", newDate );
				$( "#CheckOut1" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut1" ).datepicker({
			dateFormat: "yy-mm-dd",
			changeMonth: true,
			numberOfMonths: 1,
		});

}());